import { createSvgIcon } from "@mui/material/utils";

const PlusIcon = createSvgIcon(
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M12 4.5v15m7.5-7.5h-15"
    stroke="currentColor"
    strokeWidth="3.5"
    fill="none"
  />,
  "Plus"
);

export default PlusIcon;
